module.exports = "\n<div class=\"main-menu-list\"><div class=\"d-flex flex-column\">\n  <div class=\"mini-menu-item\">Remove</div>\n  <div class=\"mini-menu-item\">Rename...</div>\n  <div class=\"mini-menu-item\">Duplicate</div>\n  <div class=\"mini-menu-item\">Add product</div>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dealer/menu-main/index.html
// module id = ./src/app/components/dealer/menu-main/index.html
// module chunks = main